import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyApqWwdcnlJHVB1qN2WHAsPef7bEftU__A",
  authDomain: "foodie-b9ea0.firebaseapp.com",
  databaseURL: "https://foodie-b9ea0-default-rtdb.firebaseio.com",
  projectId: "foodie-b9ea0",
  storageBucket: "foodie-b9ea0.appspot.com",
  messagingSenderId: "263699282615",
  appId: "1:263699282615:web:ce60aaeef72a5513a96b32",
  measurementId: "G-WGXTVKR5N8",
};

const app = getApps.length > 0 ? getApp() : initializeApp(firebaseConfig);

const firestore = getFirestore(app);

const storage = getStorage(app);

export { app, firestore, storage };
